import {view} from '@sail/ui';
import {useTheme} from '@stripe-internal/conversations-ui';

interface Props {
  children: React.ReactNode;
}

export function FormContainer({children}: Props) {
  const theme = useTheme();
  return (
    <view.div
      css={{
        background: theme.formBorderColor,
        borderRadius: 'large',
        padding: '1px',
      }}
    >
      <view.div
        css={{
          backgroundColor: 'surface',
          borderRadius: '11px',
          width: 'fill',
          height: 'fill',
          padding: '16px',
        }}
      >
        {children}
      </view.div>
    </view.div>
  );
}
